import React from 'react';

import { IIconProps, TIconType } from '../interface';

const ChevronDownIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-testid='chevron-down'
			fill='none'
			height='8'
			viewBox='0 0 12 8'
			width='12'
			{...props?.innerSvgProps}
		>
			<path
				d='M0 1.37487L6 7.37487L12 1.37487L11.2501 0.625L6 5.87513L0.749868 0.625L0 1.37487Z'
				fill='#2E2E6B'
			/>
		</svg>
	);
};

export default ChevronDownIcon;
